// Copyright Epic Games, Inc. All Rights Reserved.

import { ILocalizationMessages, ILocalizationState } from "./reducer";

export const PATCH_LOCALIZATION_MESSAGES = "PATCH_LOCALIZATION_MESSAGES";
export const PATCH_ERROR_CODE_LOCALIZATION = "PATCH_LOCALIZATION_ERROR_CODE";
export const PATCH_LOCALIZATION = "PATCH_LOCALIZATION";

export interface IPatchLocalizationMessagesAction {
  type: typeof PATCH_LOCALIZATION_MESSAGES;
  payload: Partial<ILocalizationMessages>;
}

export interface IPatchErrorCodeLocalizationPayload {
  errorCode: string;
  title: string;
  description: string;
}

export interface IPatchErrorCodeLocalizationAction {
  type: typeof PATCH_ERROR_CODE_LOCALIZATION;
  payload: IPatchErrorCodeLocalizationPayload;
}

export interface IPatchLocalizationAction {
  type: typeof PATCH_LOCALIZATION;
  payload: ILocalizationState;
}

export type LocalizationActions =
  | IPatchErrorCodeLocalizationAction
  | IPatchLocalizationMessagesAction
  | IPatchLocalizationAction;

export function patchLocalizationMessages(
  messages: Partial<ILocalizationMessages>
): IPatchLocalizationMessagesAction {
  return {
    type: PATCH_LOCALIZATION_MESSAGES,
    payload: messages,
  };
}

export function patchErrorCodeLocalization(
  payload: IPatchErrorCodeLocalizationPayload
): IPatchErrorCodeLocalizationAction {
  return {
    type: PATCH_ERROR_CODE_LOCALIZATION,
    payload,
  };
}

export function patchLocalization(
  state: ILocalizationState
): IPatchLocalizationAction {
  return {
    type: PATCH_LOCALIZATION,
    payload: state,
  };
}
